// LatestUpload.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../utils/AuthContext/AuthContext';
import config from '../../utils/config';
import DeleteSVG from '../../assets/Delete';

const LatestUpload = ({ formType, refresh, onDeleteSuccess, onLatestUploadUpdate }) => {
  const { token, user } = useAuth();
  const [latestUpload, setLatestUpload] = useState(null);
  // const userId = JSON.parse(localStorage.getItem('user'))?.id;
  const getUserId = (user) => user.id || user._id;

  const fetchUploads = async () => {
    const userId = getUserId(user);
    try {
      const response = await fetch(`${config.apiBaseUrl}/uploads/${userId}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const filtered = data.filter(item => item.formType === formType);
      filtered.sort((a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt));
      const latest = filtered[0] || null;
      setLatestUpload(latest);

      if (onLatestUploadUpdate && latest) {
        onLatestUploadUpdate(latest.url);
      }
      return filtered;
    } catch (err) {
      console.error('Error fetching uploads:', err);
    }
  };

  const handleDelete = async () => {
    if (!latestUpload) return;
    try {
      const response = await fetch(`${config.apiBaseUrl}/upload/${latestUpload._id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        throw new Error('Delete failed');
      }
      const filtered = await fetchUploads();
      if (!filtered || filtered.length === 0) {
        onDeleteSuccess();
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const userId = getUserId(user);
    if (userId && token) {
      fetchUploads();
    }
  }, [user, token, formType, refresh]);

  if (!latestUpload) return null;

  return (
    <div className="latest-upload flex items-center gap-2 w-full justify-end">
        <a 
        href={latestUpload.url} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="text-shi-green hover:underline"
        >
          <span className="text-[12px] text-gray-700">{latestUpload.originalFilename}</span>
      </a>
      <button onClick={handleDelete} className="text-red-500">
        <DeleteSVG width={16} height={16} />
      </button>
    </div>
  );
};

export default LatestUpload;
